import Upload from "@/services/modules/uploads.service";
let UploadAdapter = class UploadAdapter {
  constructor(loader) {
    // CKEditor 5's FileLoader instance.
    this.loader = loader;

    this.file = null;
  }

  // Starts the upload process.
  upload() {
    return new Promise((resolve, reject) => {
      this.loader.file.then(file => {
        this.file = file;
        this._sendRequest(resolve, reject);
      });
    });
  }

  // Aborts the upload process.
  abort() {}

  // Prepares the data and sends the request.
  _sendRequest(resolve, reject) {
    const data = new FormData();

    data.append("file", this.file);

    Upload.add(data)
      .then(response => {
        resolve({
          default: response.data.url
        });
      })
      .catch(error => {
        reject(error);
      });
  }
};

export default UploadAdapter;
